module.exports = __webpack_public_path__ + "static/media/step3_j.d3bd0b51.png";